import { MoreVert } from '@mui/icons-material';
import { Box, Card, CardHeader, IconButton, Typography } from '@mui/material';
import { Income } from '../../../common/entities';

export interface IncomesListItemProps {
  income: Income;
  onMenuClick: (
    event: React.MouseEvent<HTMLButtonElement>,
    expenseId: string
  ) => void;
}

const sx = {
  width: '100%'
};

export const IncomesListItem = ({
  income,
  onMenuClick
}: IncomesListItemProps) => {
  const itemContent = (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Typography variant="h5" sx={{ marginRight: '10px' }}>
        {income.name}
      </Typography>
      {/* {income. ? (
        <Chip label="Accumulation" color="primary" size="small" />
      ) : (
        <Chip label="Budget" color="success" size="small" />
      )} */}
    </Box>
  );

  return (
    <Card sx={sx}>
      <CardHeader
        action={
          <IconButton
            aria-label="settings"
            onClick={e => onMenuClick(e, income.id)}
          >
            <MoreVert />
          </IconButton>
        }
        title={itemContent}
        // title={
        //   !budget.accumulation ? (
        //     <Link
        //       to={{
        //         pathname: `/budget/${budget.id}`,
        //         state: { goBackTitle: 'Back to budgets' }
        //       }}
        //       style={{ textDecoration: 'none', color: 'inherit' }}
        //     >
        //       {itemContent}
        //     </Link>
        //   ) : (
        //     <>{itemContent}</>
        //   )
        // }
      />
    </Card>
  );
};
